import React from 'react';
import {BaseWorkflow} from "./BaseWorkflow";

export class TranslationModerationWorkflow extends BaseWorkflow {

    paintVertexBasedOnStatus(vertex, nodeMap) {
        const node = nodeMap.get(vertex.id);
        console.log(node);
        if (node === undefined) {
            // Special treatment for PendingCustomerPayment
            return;
        }

        // Regular color scheme
        this.defineRegularStatusColor(node, vertex)
    }

    generateGraphElements(nodeList) {
        const nodeMap = new Map();
        nodeList.forEach(node => {
            nodeMap.set(node.id, node);
        });
        const vertices = [
            {id: 'CreateAutomatedTranslationContent', data: {label: '创建产品翻译信息'}, position: this.generateCenterPosition( {x: 0, y: 0})},
            {id: 'opsReviewTranslationContent', data: {label: '审核与发布'}, position: this.generateCenterPosition( {x: 0, y: 200})}
        ];
        vertices.forEach(vertex => {
            this.paintVertexBasedOnStatus(vertex, nodeMap);
        });
        const edges = [
            {id: 'e-CreateAutomatedTranslationContent-opsReviewTranslationContent', source: 'CreateAutomatedTranslationContent', target: 'opsReviewTranslationContent', type: 'smoothstep'}
        ];
        return [...vertices, ...edges];
    }
}